import { render, staticRenderFns } from "./RaceResultTable.vue?vue&type=template&id=589bc08b&scoped=true"
import script from "./RaceResultTable.vue?vue&type=script&lang=js"
export * from "./RaceResultTable.vue?vue&type=script&lang=js"
import style0 from "./RaceResultTable.vue?vue&type=style&index=0&id=589bc08b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../2026-08-26/github-cli-gh-codex/work/jiangkv3/web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "589bc08b",
  null
  
)

export default component.exports